import { render, staticRenderFns } from "./bulk-upload.vue?vue&type=template&id=5fed5f76&scoped=true&"
import script from "./bulk-upload.ts?vue&type=script&lang=ts&"
export * from "./bulk-upload.ts?vue&type=script&lang=ts&"
import style0 from "./bulk-upload.scss?vue&type=style&index=0&id=5fed5f76&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fed5f76",
  null
  
)

export default component.exports